import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { fetchGetLkType } from '../../repositories/lk-type/v2/get-lk-type';
import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { UnknownError } from '@cian/peperrors';

interface ILkTypeResolve {
  lkType: ELkType | null;
}

export async function getLkType(httpApi: IHttpApi, logger: ILogger, cookie?: string): Promise<ILkTypeResolve> {
  try {
    const response = await fetchGetLkType<never, never>({
      httpApi,
      config: {
        requestConfig: {
          headers: [['cookie', cookie || '']],
        },
      },
    });

    if (response.statusCode === 200) {
      return { lkType: response.response.lkType };
    }

    return { lkType: null };
  } catch (err) {
    logger.error(
      new UnknownError({
        message: 'Ошибка запроса в get-lk-type',
        domain: 'src/shared/services/getLkType/getLkType.ts',
        details: err as UnknownError,
      }),
    );

    return { lkType: null };
  }
}
